import { useEffect, useState } from 'react';

export const SEARCH_DEBOUNCE_MS = 250;

/**
 * Returns a value that settles only after the caller stops changing it.
 *
 * Search now runs on the server, so the raw input value would issue one request
 * per keystroke — each one narrowing a set the reader has already moved past.
 * The input itself stays immediate; only the value the query is keyed on waits.
 */
export function useDebounced<T>(value: T, delay = SEARCH_DEBOUNCE_MS): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [delay, value]);
  return settled;
}
